<template>
    <div v-route-title="'模板管理'">
        <div v-if="view === 'main'">
            <div class="database-view">
                <div class="header-view pr">
                    <span class="huishouzhan_title">模板管理</span>
                    <div class="btn-layer">
                        <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">添加模板</el-button>
                    </div>
                </div>
                <el-form class="search-form" inline :model="searchModel">
                    <el-form-item>
                        <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="模板ID"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="模板名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchModel.pageType" multiple clearable placeholder="页面类型">
                            <el-option v-for="type in pageTypes" :key="type.type" :value="type.type" :label="type.typeName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">搜索</el-button>
                    </el-form-item>
                </el-form>
                <div v-if="data">
                    <el-table class="yq-table" :data="data.content" style="width: 100%">
                        <el-table-column
                                type="index"
                                :index="indexMethod">
                        </el-table-column>
                        <el-table-column
                                prop="id"
                                label="ID" width="60">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="模板名称">
                        </el-table-column>
                        <el-table-column
                                label="模板类型" width="80">
                            <span slot-scope="scope">{{isAssignedTemplate(scope.row)?'系统模板':'用户模板'}}</span>
                        </el-table-column>
                        <el-table-column
                                label="页面类型" width="140">
                            <span slot-scope="scope">{{getPageType(scope.row.pageType).typeName}}</span>
                        </el-table-column>
                        <el-table-column
                                label="创建时间">
                            <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                        </el-table-column>
                        <el-table-column
                                label="创建用户" width="80">
                            <span slot-scope="scope">{{scope.row.creatorUser?scope.row.creatorUser.name:''}}</span>
                        </el-table-column>
                        <el-table-column
                                label="修改时间">
                            <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                        </el-table-column>
                        <el-table-column
                                label="修改用户" width="80">
                            <span slot-scope="scope">{{scope.row.editorUser?scope.row.editorUser.name:''}}</span>
                        </el-table-column>
                        <el-table-column
                                label="操作" width="230">
                            <template slot-scope="scope">
                                <el-link v-if="!isAssignedTemplate(scope.row)" icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                                <el-link v-if="!isAssignedTemplate(scope.row) && getPageType(scope.row.pageType).config" icon="el-icon-setting" @click="configRow(scope.row)">配置</el-link>
                                <el-link icon="el-icon-view" @click="previewRow(scope.row)">预览</el-link>
                                <el-link v-if="!isAssignedTemplate(scope.row)" icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="clear"></div>
            <div class="magin10"></div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改记录':'添加记录'" :visible.sync="dialogFormVisible" width="500px">
            <el-form ref="form" :model="model" label-width="80px" :rules="rules">
                <el-form-item label="模板名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="页面类型" prop="pageType" v-if="!model.id">
                    <el-select v-model="model.pageType">
                        <el-option v-for="type in pageTypes" :key="type.type" :value="type.type" :label="type.typeName"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import pageTemplateService from '../service/page-template'
    import pageTypeService from '../service/page-type'

    export default {
        name: "TemplateAdmin",
        data() {
            return {
                view: 'main',
                data: null,
                searchModel: {
                    id: null,
                    nameLike: null,
                    pageType: null
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    pageType: null
                },
                dialogFormVisible: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入模板名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    pageType: [
                        {required: true, message: '请选择页面类型', trigger: 'blur'}
                    ]
                },
                pageTypes: []
            }
        },
        computed: {
            ...mapState(['user'])
        },
        created(){
            pageTypeService.getAssignedPageTypes().then(pageTypes => this.pageTypes = pageTypes)
            this.fetchData(1)
        },
        methods: {
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await pageTemplateService.listPageTemplates(params)
                this.data = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow(){
                this.model = {
                    name: null,
                    pageType: null
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                pageTemplateService.getPageTemplate(row.id).then(response => {
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    if (this.model.id) {
                        pageTemplateService.updatePageTemplate(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        pageTemplateService.addPageTemplate(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(()=>{})
            },
            configRow(row) {
                const pageType = this.getPageType(row.pageType)
                if(pageType.config){
                    this.$router.push('/main/edit-template/'+row.id)
                }
            },
            previewRow(row){
                this.$router.push('/main/preview-template/'+row.id)
            },
            deleteRow(row){
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    pageTemplateService.deletePageTemplate(row.id).then(()=>{
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number>0?this.data.number:1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(()=>{
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            getPageType(type){
                return pageTypeService.getPageType(type)
            },
            isAssignedTemplate(template){
                return this.user.project && template.project !== this.user.project.id
            }
        }
    }
</script>
<style scoped>
</style>
